import React, { useEffect } from 'react';
import { useAxiosHook } from '../../hooks/ApiHooks';
import api from '../../apiConfig';
import ApiLoader from '../loading/ApiLoader';
import { Col, Row } from 'reactstrap';
import { isEmpty, get } from 'lodash';
import Accordion from '../containers/Accordion';
import DownloadFiles from '../download/DownloadFiles';
import YoutubePlayer from '../youtube/YoutubePlayer';
import ButtonReadings from '../containers/Buttons';
import { Link } from 'react-router-dom';
import routeList from '../../routes/routeList';
import SearchBox from '../containers/SearchBox';
import DocumentTitle from 'react-document-title';

const getPictureOrElsePlaceholder = projectData => {
  const pic = get(projectData, 'data.pic');
  return pic !== 'false' ? pic : '/placeholders/project.png';
};

const mapYoutubes = projectData =>
  (get(projectData, 'data.youTubes') || [])
    .map(({ url }) => url)

    .map(url => {
      if (url.includes('youtu.be')) {
        const splitUrl = url.split('/');
        return splitUrl[splitUrl.length - 1];
      }

      return new URLSearchParams(url.split('?')[1]).get('v');
    });

const Project = ({ match }) => {
  const slug = match.params.slug;
  const [projectData, getProjectData] = useAxiosHook(api.dataController, `${api.projectData}/${slug}`);
  useEffect(() => {
    getProjectData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return (
    <div className="full-wrapper flex-grow-1 subpage-margins">
      <DocumentTitle title={get(projectData, 'data.title', 'Projekt szkolny')} />
      <section className="content-wrapper">
        <SearchBox />
        <ApiLoader status={projectData.apiStatus}>
          {!isEmpty(projectData) && (
            <>
              <Row>
                <Col>
                  <h1 className="main-header">
                    <span>Projekty szkolne</span>
                  </h1>
                </Col>
              </Row>
              <Row className="mb-5">
                <Col xs="12" md="6">
                  <div
                    className="project-thumbnail"
                    style={{ backgroundImage: `url("${getPictureOrElsePlaceholder(projectData)}")` }}
                  />
                </Col>
                <Col xs="12" md="6" className="d-flex flex-column">
                  <h2
                    className="custom-h2 subtitle-1 project-title mb-3"
                    dangerouslySetInnerHTML={{ __html: get(projectData, 'data.title') }}
                  />
                  <p>
                    <strong>Autor</strong> <br /> {get(projectData, 'data.author')}
                  </p>
                  <strong>O projekcie</strong>
                  <div dangerouslySetInnerHTML={{ __html: get(projectData, 'data.description') }} />
                </Col>
              </Row>
              {(get(projectData, 'data.files') || []).length > 0 && (
                <Row>
                  <Col className="my-5">
                    <Accordion title="Pobierz załączniki" id="pobierz-zalaczniki">
                      <Row>
                        <Col className="project-download-wrapper">
                          <DownloadFiles
                            data={(get(projectData, 'data.files') || []).map(({ title, url }) => ({
                              url,
                              description: title
                            }))}
                          />
                        </Col>
                      </Row>
                    </Accordion>
                  </Col>
                </Row>
              )}
              {(get(projectData, 'data.youTubes') || []).length > 0 && (
                <>
                  <Row>
                    <Col>
                      <h5 className="main-header">
                        <span>Zobacz nagranie</span>
                      </h5>
                    </Col>
                  </Row>
                  <YoutubePlayer videoIds={mapYoutubes(projectData)} />
                </>
              )}
              {(get(projectData, 'data.galery') || []).length > 0 && (
                <>
                  <Row>
                    <Col>
                      <h5 className="main-header">
                        <span>Zobacz galerię</span>
                      </h5>
                    </Col>
                  </Row>
                  <Row className="mb-5 project-pages-img-row">
                    {(get(projectData, 'data.galery') || []).map(({ url }, idx) => (
                      <Col md="3" className="mb-4" key={idx}>
                        <div className="project-pages-img" style={{ backgroundImage: `url("${url}")` }} />
                      </Col>
                    ))}
                  </Row>
                </>
              )}
              <Row className="mb-5">
                <Link to={routeList.projects} className="ml-auto mr-auto mt-3 mb-5 text-right">
                  <ButtonReadings text="Sprawdź inne projekty" color="primary" />
                </Link>
              </Row>
            </>
          )}
        </ApiLoader>
      </section>
    </div>
  );
};

export default Project;
